import { render, staticRenderFns } from "./SubscriptionPanel.vue?vue&type=template&id=08affb5e&"
import script from "./SubscriptionPanel.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports